<span class="snackbar-icon" [ngClass]="data.type">
  <mat-icon> {{ icon }} </mat-icon>
</span>
<span class="snackbar-message" matSnackBarLabel> {{ data.message }} </span>
<span class="snackbar-action" matSnackBarActions>
  <button mat-icon-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
    <mat-icon>close</mat-icon>
  </button>
</span>
